import axios from 'axios';
import { pickBy } from 'lodash';
import {
  apiInstancesLinksUrl,
  apiInstancesLinksForInstanceLinkUrl,
  apiInstancesLinksForInstanceUrl
} from '../config';
import populatePropertys from '../utils/populatePropertys';

/**
 * GET Instance Links
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props - properties Object
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {boolean} [props.beforeThreshold] - return results before threshold (default is after)
 * @param {string} [props.deleted=exclude] - include | exclude | only
 * @param {string} [props.displaySetId] - target displaySetId
 * @param {string[]} [props.displaySetIds] - target displaySetIds
 * @param {boolean} [props.flag1] - target flag1
 * @param {boolean} [props.flag2] - target flag2
 * @param {boolean} [props.flag3] - target flag3
 * @param {boolean} [props.flag4] - target flag4
 * @param {boolean} [props.flag5] - target flag5
 * @param {boolean} [props.flag6] - target flag6
 * @param {boolean} [props.flag7] - target flag7
 * @param {boolean} [props.flag8] - target flag8
 * @param {boolean} [props.flag9] - target flag9
 * @param {boolean} [props.flag10] - target flag10
 * @param {string} [props.instanceLinkUUID] - target instanceLinkUUID
 * @param {string[]} [props.instanceLinkUUIDs] - target instanceLinkUUIDs
 * @param {string} [props.instanceUUID] - target instanceUUID
 * @param {string[]} [props.instanceUUIDs] - target instanceUUIDs
 * @param {string} [props.linkedProfileUUID] - target linkedProfileUUID
 * @param {boolean} [props.messagesEnabled] - target messagesEnabled
 * @param {string} [props.orgGroupUUID] - target orgGroupUUID
 * @param {string} [props.orgLocationUUID] - target orgLocationUUID
 * @param {string} [props.orgUnitUUID] - target orgUnitUUID
 * @param {string} [props.orgUUID] - target orgUUID
 * @param {string} [props.profileUUID] - target profileUUID
 * @param {string} [props.refresh=false] - refresh server cache
 * @param {boolean} [props.shared] - target shared
 * @param {string} [props.thresholdDateTime] - target threshold datetime
 * @param {string} [props.useCache=false] - use server cache
 * @returns {ApiResponse}
 */
const getInstanceLinks = (props = {}) => {
  const {
    displaySetId,
    displaySetIds,
    deleted = 'exclude',
    instanceLinkUUID,
    instanceLinkUUIDs,
    instanceUUID,
    instanceUUIDs,
    refresh = false,
    requestConfig,
    useCache = false
  } = props;

  const method = 'get';
  let url = apiInstancesLinksUrl;

  if (instanceLinkUUID) {
    url = apiInstancesLinksForInstanceLinkUrl.replace(
      /{instanceLinkUUID}/g,
      instanceLinkUUID
    );
  }

  if (instanceUUID) {
    url = apiInstancesLinksForInstanceUrl.replace(
      /{instanceUUID}/g,
      instanceUUID
    );
  }

  const populatedPropertys = populatePropertys({
    capDestProp: true,
    propertyNames: [
      'beforeThreshold',
      'displaySetId',
      'flag1',
      'flag2',
      'flag3',
      'flag4',
      'flag5',
      'flag6',
      'flag7',
      'flag8',
      'flag9',
      'flag10',
      'instanceLinkUUID',
      'instanceUUID',
      'linkedProfileUUID',
      'messagesEnabled',
      'orgGroupUUID',
      'orgLocationUUID',
      'orgUnitUUID',
      'orgUUID',
      'profileUUID',
      'shared',
      'thresholdDateTime'
    ],
    source: props
  });

  const params = pickBy(
    {
      Deleted: deleted,
      'DisplaySetIds[]': displaySetId ? undefined : displaySetIds,
      'InstanceUUIDs[]': instanceUUID ? undefined : instanceUUIDs,
      'InstanceLinkUUIDs[]': instanceLinkUUID ? undefined : instanceLinkUUIDs,
      Refresh: refresh,
      UseCache: useCache,
      ...populatedPropertys
    },
    property => typeof property !== 'undefined'
  );

  return axios({
    method,
    params,
    url,
    ...requestConfig
  });
};

export default getInstanceLinks;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/getInstanceLinks.js